var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-pane-inner" }, [
    _c("div", { staticClass: "go-add-input" }, [
      _c("div", { staticClass: "go-note-write" }, [
        _c("div", { staticClass: "go-note-header" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.item.title,
                expression: "item.title",
              },
            ],
            staticClass: "go-form-control",
            attrs: {
              maxlength: "100",
              placeholder: _vm.$t(
                "popupAddReference.noteTab.placeHolderTitleInput"
              ),
              type: "text",
            },
            domProps: { value: _vm.item.title },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.item, "title", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-note-body" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.item.content,
                expression: "item.content",
              },
            ],
            staticClass: "go-form-control",
            attrs: {
              placeholder: _vm.$t(
                "popupAddReference.noteTab.placeHolderDescriptionInput"
              ),
              rows: "3",
            },
            domProps: { value: _vm.item.content },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.item, "content", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-note-footer" }, [
          _c("div", { staticClass: "go-elements" }, [
            _c("div", { staticClass: "go-count-check" }, [
              _c("strong", { staticClass: "go-count-current" }, [
                _vm._v(_vm._s(_vm.item.content.length)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "go-count-standard" }, [
                _vm._v(
                  _vm._s(_vm.$t("popupAddReference.noteTab.limitOfText")) + " "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-elements" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-outline-primary bo-btn-sm",
                class: {
                  disabled:
                    !_vm.item.content ||
                    _vm.removeUnUsedSpace(_vm.item.content).length < 100 ||
                    !_vm.item.title ||
                    _vm.removeUnUsedSpace(_vm.item.title).length < 1,
                },
                attrs: { type: "button" },
                on: { click: _vm.addToArr },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("popupAddReference.noteTab.buttonAddTitle")) +
                    "\n          "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "go-list-wrap" },
      [
        _vm.allItem.length == 0
          ? _c("div", { staticClass: "go-empty" }, [
              _c("i", { staticClass: "go-icon-32 go-icon-edit" }),
              _vm._v(" "),
              _c("p", { staticClass: "go-info-lead" }, [
                _vm._v(
                  _vm._s(_vm.$t("popupAddReference.noteTab.strongDescription"))
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "go-info-text" }, [
                _vm._v(
                  _vm._s(_vm.$t("popupAddReference.noteTab.longDescription"))
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "vue-custom-scrollbar",
          {
            staticClass:
              "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
            attrs: { settings: _vm.scrollSettings },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "auto",
                  height: "auto",
                },
              },
              [
                _c(
                  "ul",
                  { staticClass: "go-card-sub-list go-card-resource" },
                  _vm._l(_vm.allItem, function (refItem) {
                    return _c("ref-item", {
                      key: refItem.id,
                      attrs: {
                        "form-model": refItem,
                        "is-has-link": false,
                        "remove-able": true,
                      },
                      on: {
                        remove: function ($event) {
                          return _vm.removeCardInList(refItem)
                        },
                        toggleBookmark: function ($event) {
                          return _vm.selectAddingReferenceDocument(refItem)
                        },
                      },
                    })
                  }),
                  1
                ),
              ]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }